// Entry point for the build script in your package.json
import '@hotwired/turbo-rails'
import './controllers'
import 'flowbite/dist/flowbite.turbo.js'
import './icon'
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

//fixing focus issue after closing modal
document.addEventListener('turbo:load', () => {
  document.addEventListener('click', (event) => {
    const hideButton = event.target.closest('[data-modal-hide]');
    if (hideButton) {
      hideButton.blur();
      
      document.body.focus();
    }
  });
});

